import BaseValidation from 'validations/BaseValidation';

export default class AmountValidation extends BaseValidation<string, null> {
    execute(): boolean {
        return (/^[1-9]\d*$/u).test(this.attribute);
    }
}
